import React, { useState } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'dva'
import Form from 'rc-field-form'
import { useHistory } from 'react-router-dom'
import { FormItem, Button } from 'components'
import { Input, PhoneInput, CodeInput } from 'app/login/components'
import { phoneValidator, checkPassWord } from 'utils'
import styles from './index.module.less'

const PasswordInput = ({ ...props }) => {
  const [focus, setFocus] = useState(false)

  return (
    <Input
      type={focus ? 'password' : 'text'}
      onKeyDown={() => setFocus(true)}
      {...props}
    />
  )
}

const selector = ({ loading }) => ({
  loading: loading.effects['login/resetPassword'],
})
export default function Index() {
  const dispatch = useDispatch()
  const { loading } = useSelector(selector, shallowEqual)
  const history = useHistory()
  const [mobile, setMobile] = useState({})
  const [workId, setWorkId] = useState('')
  const [form] = Form.useForm()

  // 输入时触发
  const valuesChange = () => {
    const values = form.getFieldsValue()
    setWorkId(values?.workId)
    setMobile(values?.mobile)
    if (!values.password && values.password !== 0) return
  }

  // 提交
  const onFinish = async values => {
    await dispatch({
      type: 'login/resetPassword',
      payload: {
        ...values,
        areaCode: values.mobile.areaCode,
        mobile: values.mobile.mobile,
      },
    })
    history.goBack()
  }

  // 校验密码
  const passWord = (rule, value, callback) => {
    let grade = checkPassWord(value)
    if (!value || value === undefined) return Promise.reject('请输入新密码')
    if (value.length < 8 || value.length > 20) {
      return Promise.reject('密码长度为8-20位的数字/字母/符号')
    }
    if (!grade) {
      return Promise.reject(
        '密码安全性过低，至少包含数字/大写字母/小写字母/符号中的三项'
      )
    }
    Promise.resolve()
    callback()
  }

  // 确认密码
  const confirmPass = (rule, value, callback) => {
    let formvalue = form.getFieldsValue()
    if (!value || value === undefined) return Promise.reject('请确认新密码')
    if (formvalue.password !== value) {
      return Promise.reject('两次密码输入不一致')
    }
    Promise.resolve()
    callback()
  }

  return (
    <div>
      {/* <div className={styles.title}>重置密码</div> */}
      <Form
        form={form}
        className={styles.cont}
        onFinish={onFinish}
        onValuesChange={valuesChange}>
        <div className={styles.formItem}>
          <FormItem
            name="workId"
            rules={[{ required: true, message: '请输入工号' }]}>
            <Input placeholder="请输入工号" trim={true} maxLength={20} />
          </FormItem>
        </div>
        <div className={styles.formItem}>
          <FormItem
            name="mobile"
            rules={[
              { required: true, message: '请输入手机号码' },
              { validator: phoneValidator },
            ]}>
            <PhoneInput placeholder="请输入手机号码" maxLength={11} />
          </FormItem>
        </div>
        <div className={styles.code}>
          <FormItem
            name="validCode"
            rules={[
              { required: true, message: '请输入验证码' },
              { pattern: /^\d{6}$/, message: '请输入正确的验证码' },
            ]}>
            <CodeInput
              mobile={{ ...mobile, workId, smsType: 'RESET_PASSWORD' }}
              maxLength={6}
            />
          </FormItem>
        </div>
        <div className={styles.formItem}>
          <FormItem
            name="password"
            rules={[
              {
                required: true,
                validator: (rule, value, callback) =>
                  passWord(rule, value, callback),
              },
            ]}>
            <PasswordInput placeholder="请输入新密码" />
          </FormItem>
        </div>
        <div className={styles.formItem}>
          <FormItem
            name="newPassword"
            rules={[
              {
                required: true,
                validator: (rule, value, callback) =>
                  confirmPass(rule, value, callback),
              },
            ]}>
            <PasswordInput placeholder="请确认新密码" />
          </FormItem>
        </div>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          className={styles.loginBut}>
          提 交
        </Button>
        <span className={styles.forget} onClick={() => history.goBack()}>
          返回登录
        </span>
      </Form>
    </div>
  )
}
